import { get, post, applicationJson } from "@/utils/request";
// 归属大区
export const GetRegions = () => get("/api/Organization/GetRegions");
// 获取归属大区下的归属公司
export const GetCompaniesByRegionId = (params: any) =>
  get("/api/Company/GetCompaniesByRegionId", params);
// 审批节点
export const getApproveNodeList = (params: any) =>
  post("/api/systemDic/getFlowNodeSearch", params);
// 获取表格搜索条件
export const getCompanyBusinessSearch = () =>
  post("/api/systemDic/getCompanyBusinessSearch");
// 获取申请人头部信息
export const getApplyUserInfo = (params: { staffId: number | string }) =>
  post("/api/Staff/info", params);
//获取大区列表
export const GetFilterRegions = (params: { KeyWord: string }) =>
  post("/api/region/list", params);
//获取法人列表
export const GetFilterStaff = (params: { SearchWords: string }) =>
  post("/api/staff/list", params);
//获取城市
export const GetCity = (params: { KeyWord: string }) =>
  post("/api/city/list", params);
// 匹配公司编码
export const MatchPrefixCode = (params: {
  CompanyName: string;
}) => post("/api/companyAccount/matchPrefixCode", params);
//下载手册
export const manual = (params: { Name: string }) =>
  get("/api/template/manual/" + params.Name);
// 判断用户是否首次进入系统
export const staffGetStaffConfig = () => post("/api/staff/GetStaffConfig");
